export default __webpack_public_path__ + "static/media/pantry1-afterB.5185f6cd.jpg";